export const getMetaValue = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }
  const tag = document.querySelector(`meta[name="${name}"]`);
  const content = tag?.getAttribute('content');
  return content ?? null;
};

export const getDntValue = () => {
  if (typeof navigator === 'undefined') {
    return null;
  }
  const dnt =
    navigator.doNotTrack ||
    (window as any).doNotTrack ||
    (navigator as any).msDoNotTrack ||
    null;
  return dnt === null || dnt === undefined ? null : String(dnt);
};

export const getGpcValue = () => {
  if (typeof navigator === 'undefined') {
    return null;
  }
  if (typeof (navigator as any)?.globalPrivacyControl === 'boolean') {
    return (navigator as any).globalPrivacyControl;
  }
  return null;
};

export const getCookieValue = (name: string) => {
  if (!name || typeof document === 'undefined') {
    return null;
  }
  const cookies = document.cookie ? document.cookie.split(';') : [];
  for (const cookie of cookies) {
    const [rawKey, ...rest] = cookie.trim().split('=');
    if (rawKey === name) {
      const rawValue = rest.join('=');
      return rawValue ? decodeURIComponent(rawValue) : '';
    }
  }
  return null;
};
